export default {
  environment: process.env.DK_ENVIRONMENT,
  useSiteUrl: process.env.DK_USE_SITE_URL === "true",
  apiVersion: process.env.DK_API_VERSION,
  baseUrl: process.env.DK_BASE_URL,
  DK_SENTRY_ENABLED_LOCAL: process.env.DK_SENTRY_ENABLED_LOCAL === "true",
};
